module.exports = __webpack_public_path__ + "images/fcf399e4696bebb42a51a9dfe1687d32-25_badge.png";